import {Location} from 'react-router-dom'
import * as React from 'react'
import {Component, ReactElement} from 'react'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../shared/hoc/createResidentWithErrorHandlingPage'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import ReservationsRepository from './ReservationsRepository'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {getQueryParameter} from '../../__NoAutomatedTests/common/util/Natutil'
import {HttpError} from '../../network/errors/HttpError'
import {HttpStatusCode} from '../../network/Constants'

interface Props {
    reservationsRepository: ReservationsRepository
    location: Location
    eventEmitter: EventEmitterExResident,
}

const KEY_CONDOMINIUM_CD = 'selectedCondominiumCd'

class ResidentAccessControlManagerForRikbRedirectPage extends Component<Props & ResidentWithErrorHandlingPagePropsSet> {
    constructor(props: Readonly<Props & ResidentWithErrorHandlingPagePropsSet>) {
        super(props)
    }

    async componentDidMount(): Promise<void> {
        const {
            reservationsRepository,
            navigate,
            location,
            eventEmitter,
            asyncCallFunction,
        } = this.props

        await eventEmitter.showLoading()

        const condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_CONDOMINIUM_CD)
        const keyBoxId = getQueryParameter('keyBoxId', location.search)
        if (condominiumCd === null || keyBoxId === '') {
            return
        }

        try {
            const redirectUrlForRikb = await asyncCallFunction(
                reservationsRepository.getRikbRedirectUrlFromReservations.bind(
                    reservationsRepository,
                    condominiumCd,
                    keyBoxId,
                ),
                (requestError) => {
                    if (requestError instanceof HttpError) {
                        if (requestError.status === HttpStatusCode.CLIENT_ERROR) {
                            navigate(
                                `/resident/not-found`,
                                {replace: true, state: {message: requestError.responseBody.requestError.message,}},
                            );
                        }
                    }
                },
            )
            if (redirectUrlForRikb && redirectUrlForRikb.details) {
                window.location.href = redirectUrlForRikb.details;
            }
        } finally {
            eventEmitter.closeLoading()
        }
    }

    render(): ReactElement {
        return <></>
    }
}

export default createResidentWithErrorHandlingPage(ResidentAccessControlManagerForRikbRedirectPage)
